import React from 'react';
import RegisterForm from '../components/common/RegisterForm';

const RegisterPage = () => {
  return <RegisterForm />;
};

export default RegisterPage;